module.exports = require("././angucomplete-alt.js");
require("././angucomplete-alt.css");


//////////////////
// WEBPACK FOOTER
// angucomplete-alt (bower component)
// module id = 47
// module chunks = 0